export default function FormNavigation({
  canGoNext,
  currentStep,
  goBack,
  goNext,
  handleSubmit,
  loading,
  nextStepValidationMessage,
  submitting,
  submitDisabled = false,
  t,
}) {
  return (
    <div className="mt-8 space-y-3">
      {currentStep < 5 && nextStepValidationMessage && (
        <div
          className="rounded-2xl border border-[#d8b769]/45 bg-[#f5df9a] px-4 py-3 text-sm font-semibold text-black shadow-lg shadow-[#d8b769]/10"
          data-testid="next-step-validation-message"
        >
          {nextStepValidationMessage}
        </div>
      )}

      <div className="flex justify-between gap-3">
        {currentStep > 1 ? (
          <button
            onClick={goBack}
            disabled={loading || submitting}
            className="rounded-2xl border border-white/10 bg-white/5 px-6 py-3 font-semibold text-foreground shadow-xl backdrop-blur-md transition hover:bg-white/10"
          >
            ← {t.back}
          </button>
        ) : (
          <div></div>
        )}

        {currentStep < 5 ? (
          <button
            onClick={goNext}
            disabled={loading || submitting || !canGoNext()}
            className="premium-button bg-gradient-to-r from-cyan-500 to-blue-600 px-8 py-3 text-white shadow-xl shadow-cyan-500/20 hover:from-cyan-400 hover:to-blue-500 disabled:bg-none disabled:bg-muted disabled:text-muted-foreground disabled:shadow-none"
          >
            {loading ? "..." : t.next} →
          </button>
        ) : (
          <button
            onClick={handleSubmit}
            disabled={submitting || loading || submitDisabled}
            className="premium-button bg-gradient-to-r from-cyan-500 to-blue-600 px-8 py-3 text-white shadow-xl shadow-cyan-500/20 hover:from-cyan-400 hover:to-blue-500 disabled:bg-none disabled:bg-muted disabled:text-muted-foreground disabled:shadow-none"
          >
            {submitting ? "..." : t.submit}
          </button>
        )}
      </div>
    </div>
  );
}
